import React from 'react'
import locale, {langPrefix} from 'shared/i18n/react'
import {Link} from 'react-router-dom'

class Feedback extends React.Component {
  constructor(props) {
    super(props)
    this.langPrefix = langPrefix()
  }

  render () {
    return (
      <div className="component-feedback">
        <Link to={`${this.langPrefix}/submit-tip`} title={locale.buttons.submitTipTitle}>{locale.buttons.submitTip}</Link>
      </div>
    )
  }
}

export default Feedback



// WEBPACK FOOTER //
// ./assets/js/components/static/feedback.jsx